import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function SweetPotatoTortilla() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Falafels</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>3 sweet potatoes
        <br></br>2 tbsp olive oil<br></br>
        100g baby spinach<br></br>6 large eggs<br></br>
        100g feta, crumbled<br></br>
      </Typography>

      <Typography>
        Pierce the potatoes a few times on each side. Microwave on high for 5-8
        mins until soft, then set aside to cool a little.
        <br>
          <br></br>
        </br>
        Heat the oil in a 20cm ovenproof frying pan and wilt the spinach for a
        minute or two (you might have to do this in batches). Cut each potato in
        half lengthways and use a spoon to scoop out the flesh, keeping it in
        big chunks. Whisk the eggs.
        <br>
          <br></br>
        </br>
        Add the sweet potato to the pan and stir to combine with the spinach -
        don't break it up too much. Pour in the egg and swirl around so it fills
        any gaps in the pan. Scatter over the feta and cook for 4-5 mins over a
        low heat until the bottom and sides are set.
        <br>
          <br></br>
        </br>
        Place under the grill for 1-2 mins to cook the top - poke a knife into
        the centre to ensure it's cooked through. Cool before slicing into
        wedges. Will keep chilled for up to a day.
        <br>
          <br></br>
        </br>
      </Typography>
    </Card>
  );
}
